
import React, { useMemo, useState, useCallback, useEffect } from "react";
import PlanificarTable from "./PlanificarTable";
import AgregarPlanificacion from "./AgregarPlanificacion";
import { COLUMNS } from "../Utils/ColumnsPlanificacion";
import { EnumTablaPaginacion, EnumAreaNegocio, EnumIndicadoresInformesConservacion } from "../../../Utils/Enumeradores/ComunEnum";
import useLogin from "../../Autenticacion/Hooks/useLogin";
import { ObtenerPlanesConservacion } from "../Services/ObtenerPlanesConservacion";
import { ObtenerIndicador } from "../Services/ObtenerIndicador";
import { ObtenerPlan } from "../Services/ObtenerPlan";
import { format } from 'date-fns';

const PlanificarCargaInformes = () => {
	const [agregarPlanificacion, setAgregarPlanificacion] = useState(false);
	const [indicadoresExigencia, setIndicadoresExigencia] = useState([]);
	const handleShowAgregarPlan = () => setAgregarPlanificacion(true);
	const [datosModal, setDatosModal] = useState(null);
	const [datosPlan, setDatosPlan] = useState(null);
	const [elemento, setElemento] = useState(null);
	const [pageCount, setPageCount] = useState(0);
	const [data, setData] = useState([]);
	const [primeraFecha, setPrimeraFecha] = useState();
	const [existenFechasCargas, setExistenFechasCargas] = useState();
	const [editar, setEditar] = useState(false);
	const handleCloseAgregarPlan = () => {
		setAgregarPlanificacion(false) 
		setEditar(false)
		setDatosPlan(null);
	};
	const obtenerFechaHoy = () => {
		const hoy = new Date();
		const dia = String(hoy.getDate()).padStart(2, '0');
		const mes = String(hoy.getMonth() + 1).padStart(2, '0');
		const año = hoy.getFullYear();
		
		return `${dia}-${mes}-${año}`;
	};

	const fechaHoy = obtenerFechaHoy();
	const [cambiarFecha, setCambiarFecha] = useState(false);
	let [fechaPlanificada, setFechaPlanificada] = useState(false);
	const columns = useMemo(() => COLUMNS, []);
	const { usuario } = useLogin();
	const [{ pageIndex, pageSize, sortBy }, setPagination] =
			useState({
				pageIndex: 0,
				pageSize: EnumTablaPaginacion.CantidadPaginacion,
				sortBy: []
			});

	
	const formatearDatos = (datos) => {
		return datos.map((item) => ({
			...item,
			fechaPlanificada: item.fechaPlanificada
				? format(new Date(item.fechaPlanificada), 'dd-MM-yyyy')
				: '',
			informesConservacion: {
				...item.informesConservacion,
				fechaCarga: item.informesConservacion?.fechaCarga
					? format(new Date(item.informesConservacion.fechaCarga), 'dd-MM-yyyy')
					: '',
				fechaInformado: item.informesConservacion?.fechaInformado
					? format(new Date(item.informesConservacion.fechaInformado), 'dd-MM-yyyy HH:mm:ss')
					: '',
			},
		}));
		
	};

	const postBusquedaObjetarEvento = async (values) => {
		const resp = await ObtenerPlanesConservacion(values);
		if (resp) {
			if (resp.status === 200) {
				const datosFormateados = formatearDatos(resp.data.listadoPlanes);
				setPageCount(resp.data.cantidadPaginas);
				setData(datosFormateados);
			} else if (resp.status === 206) {
				setPageCount(0);
				setData([]);
			}
		}
	};
		
	const fetchData = useCallback(({ formulario, pageIndex, sortBy = []}) => {
		formulario.paginacion.numeroPagina = pageIndex + 1;
		formulario.paginacion.ordenadoPor = sortBy.length > 0 ? sortBy[0].id : formulario.paginacion.ordenadoPor;
		formulario.paginacion.orderByAscending = sortBy.length > 0 ? !sortBy[0].desc : formulario.paginacion.orderByAscending;
		postBusquedaObjetarEvento(formulario);
	}, []);

	useEffect(() => {
		if(editar) {
			const usuarioId = {
				idUsuario: usuario.id,
				planConservacionId: datosModal.planConservacionId
			};
			if(datosModal.indicador.indicadorId === EnumIndicadoresInformesConservacion.SEV 
			  || datosModal.indicador.indicadorId === EnumIndicadoresInformesConservacion.SOS 
			  || datosModal.indicador.indicadorId === EnumIndicadoresInformesConservacion.ILUE)
			{
				setElemento(true);
			}
			else
			{
				setElemento(false);
			}
		
			async function fetchObtenerPlan() {
				try {
					const response = await ObtenerPlan(usuarioId);
					if (response && response.status === 200 && response.data) {
                    	setDatosPlan(response.data);
					}
				} catch (error) {
					console.error("Error obteniendo indicadores:", error);
				}
			}
		
			fetchObtenerPlan();
		}
	}, [editar, agregarPlanificacion]);

	useEffect(() => {
		const usuarioId = {
			idUsuario: usuario.id,
			areaNegocioId: EnumAreaNegocio.Conservacion
		};
	
		async function fetchIndicadores() {
			try {
				const response = await ObtenerIndicador(usuarioId);
				if (response && response.status === 200 && response.data) {
					setIndicadoresExigencia(response.data);
				}
			} catch (error) {
				console.error("Error obteniendo indicadores:", error);
			}
		}
	
		fetchIndicadores();
	}, [agregarPlanificacion]);

	useEffect(() => {
		if (editar)
		{
			const fechaPlanificadaStr = datosModal.fechaPlanificada;
			setFechaPlanificada(fechaPlanificadaStr);

			const fechaPlanificadaObj = new Date(
				fechaPlanificadaStr.split("-").reverse().join("-")
			);
			const fechaHoyObj = new Date(
				fechaHoy.split("-").reverse().join("-")
			);

			if (fechaPlanificadaObj <= fechaHoyObj) 
			{
				setCambiarFecha(true);
				setPrimeraFecha(true);
			}	
			else 
			{
				setCambiarFecha(false);
				setPrimeraFecha(true);
			}
		}
		else
		{
			setPrimeraFecha(false);
			setCambiarFecha(false);
			setExistenFechasCargas(false);
		}
	}, [editar])

	return (
		<div>
			{agregarPlanificacion || (editar && datosPlan) ? 
				<AgregarPlanificacion
					handleCloseAgregarPlan={handleCloseAgregarPlan}
					datosModal={datosPlan}
					editar={editar}
					indicadoresExigencia={indicadoresExigencia}
					cambiarFecha={cambiarFecha}
					fechaPlanificada={fechaPlanificada}
					elemento={elemento}
					setDatosPlan={setDatosPlan}
					setElemento={setElemento}
					primeraFecha={primeraFecha}
					fechaHoy={fechaHoy}
					setPrimeraFecha={setPrimeraFecha}
					datosEditar={datosModal}
					existenFechasCargas={existenFechasCargas}
				/>
			:
				<PlanificarTable
					handleShowAgregarPlan={handleShowAgregarPlan}
					setDatosModal={setDatosModal}
					columns={columns}
					data={data}
					indicadoresExigencia={indicadoresExigencia}
					fetchData={fetchData}
					pageCount={pageCount}
					currentpage={pageIndex}
					pageSize={pageSize}
					sortBy={sortBy}
					setPagination={setPagination}
					setEditar={setEditar}
					fechaHoy={fechaHoy}
					setExistenFechasCargas={setExistenFechasCargas}
				/>
			}
		</div>
	)
}
export default PlanificarCargaInformes;
